import { Language } from '@nxt-insurance/constants'

import { CALENDLY_STAGING_LINK } from '@flows/configs/shared/mgaLight/constants'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { ChildSavingStepParams } from './types'
import { successSchema } from './types'

const getCalendlyLink = (params: ChildSavingStepParams) => {
  if (params.environment === 'production') {
    return params.getCurrentLanguage() === Language.De
      ? 'https://calendly.com/getsafe-leben-gesundheit/av-kinder'
      : 'https://calendly.com/getsafe-leben-gesundheit/pension-children'
  }

  return CALENDLY_STAGING_LINK
}

export const success = (params: ChildSavingStepParams) => {
  return {
    schema: successSchema,
    stepContent: [
      {
        type: 'animation',
        width: 140,
        height: 140,
        source: require('@ui-kit/assets/animations/check.json') as string,
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.text',
        },
      },
      {
        type: 'calendly',
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.title',
        },
        subtitle: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.subtitle',
        },
        link: getCalendlyLink(params),
        bgColor: 'grey100',
      },
    ],
    subFlow: SubFlow.Common,
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    hideBackButton: true,
    buttonLabel: {
      type: 'translatableText',
      translationKey: 'sharedFlows_childSaving:steps.success.proceedButtonLabel',
    },
    footer: { hideFooter: true },
    nextStep: 'appointment_details',
  } as const satisfies AnyStepConfiguration
}
